import preval from 'preval.macro';

export default preval`module.exports = require('config');`;
